/**
 * PostHog Analytics Helper — The Obesity Killer
 * Reusable tracking for consultative assessment + booking funnel.
 *
 * Requires: window.posthog (PostHog JS SDK + init loaded in theme.liquid)
 */
(function () {
  'use strict';

  var POSTHOG_DEBUG = false;
  var POSTHOG_ASSESSMENT_SAMPLE_RATE = 1.00;
  var SAMPLE_KEY = 'obesity_killer_posthog_sampled_v1';
  var DEDUP_KEY = 'obesity_killer_ph_fired_v1';
  var FLOW_VERSION = 'v1';

  /* ── Sampling ────────────────────────────────────────────────── */
  function _storageGet(key) {
    try { return sessionStorage.getItem(key); } catch (_) { return null; }
  }
  function _storageSet(key, val) {
    try { sessionStorage.setItem(key, val); } catch (_) {}
  }

  function isSampled() {
    var raw = _storageGet(SAMPLE_KEY);
    if (raw === '1') return true;
    if (raw === '0') return false;
    var sampled = Math.random() < POSTHOG_ASSESSMENT_SAMPLE_RATE;
    _storageSet(SAMPLE_KEY, sampled ? '1' : '0');
    if (POSTHOG_DEBUG) console.log('[PH] Sampling decision:', sampled);
    return sampled;
  }

  /* ── Deduplication (persistent per journey) ──────────────────── */
  function _loadFiredSet() {
    try {
      var raw = _storageGet(DEDUP_KEY);
      return raw ? JSON.parse(raw) : [];
    } catch (_) {
      return [];
    }
  }

  function _saveFiredSet(arr) {
    try { _storageSet(DEDUP_KEY, JSON.stringify(arr)); } catch (_) {}
  }

  function _hasFired(key) {
    return _loadFiredSet().indexOf(key) !== -1;
  }

  function _markFired(key) {
    var arr = _loadFiredSet();
    if (arr.indexOf(key) === -1) {
      arr.push(key);
      _saveFiredSet(arr);
    }
  }

  function resetSession() {
    try { sessionStorage.removeItem(DEDUP_KEY); } catch (_) {}
  }

  /* ── Safe tracking ───────────────────────────────────────────── */
  var QUESTION_MAP = {
    q1:  { key: 'body_profile',       order: 1,  section: 'about_you' },
    q8:  { key: 'eligibility',        order: 2,  section: 'suitability_check' },
    q2:  { key: 'weight_loss_difficulty', order: 3, section: 'challenges' },
    q3:  { key: 'previous_attempts',  order: 4,  section: 'experience' },
    q4:  { key: 'quit_reason',        order: 5,  section: 'pattern' },
    q5:  { key: 'lifestyle',          order: 6,  section: 'routine' },
    q6:  { key: 'digestive_health',   order: 7,  section: 'digestive_health' },
    q7:  { key: 'medical_conditions', order: 8,  section: 'health' },
    q9:  { key: 'motivation',         order: 9,  section: 'motivation' },
    q10: { key: 'urgency',            order: 10, section: 'timeline' },
    lead: { key: 'full_name',         order: 11, section: 'contact' },
  };

  function _safeTrack(event, props) {
    if (typeof posthog === 'undefined' || !posthog.capture) return;
    if (!isSampled()) return;
    try { posthog.capture(event, props || {}); } catch (e) {}
    if (POSTHOG_DEBUG) console.log('[PH]', event, props || {});
  }

  function _qMeta(screenName) {
    var q = QUESTION_MAP[screenName];
    if (!q) return null;
    return { flow_version: FLOW_VERSION, question_key: q.key, question_order: q.order, section_key: q.section };
  }

  /* ── Public API ──────────────────────────────────────────────── */
  var TokAnalytics = {
    resetSession: resetSession,
    resetSessionAndSample: function () {
      resetSession();
      try { sessionStorage.removeItem(SAMPLE_KEY); } catch (_) {}
    },

    assessmentStarted: function () {
      var k = 'assessment_started';
      if (_hasFired(k)) return;
      _markFired(k);
      _safeTrack('assessment_started', { flow_version: FLOW_VERSION });
    },

    questionViewed: function (screenName) {
      var meta = _qMeta(screenName);
      if (!meta) return;
      var k = 'viewed:' + meta.question_key;
      if (_hasFired(k)) return;
      _markFired(k);
      _safeTrack('assessment_question_viewed', meta);
    },

    questionAnswered: function (screenName) {
      var meta = _qMeta(screenName);
      if (!meta) return;
      var k = 'answered:' + meta.question_key;
      if (_hasFired(k)) return;
      _markFired(k);
      _safeTrack('assessment_question_answered', meta);
    },

    otpVerified: function () {
      var k = 'otp_verified';
      if (_hasFired(k)) return;
      _markFired(k);
      _safeTrack('otp_verified', { flow_version: FLOW_VERSION });
    },

    assessmentCompleted: function () {
      var k = 'assessment_completed';
      if (_hasFired(k)) return;
      _markFired(k);
      _safeTrack('assessment_completed', { flow_version: FLOW_VERSION });
    },

    slotBookingViewed: function () {
      var k = 'slot_booking_viewed';
      if (_hasFired(k)) return;
      _markFired(k);
      _safeTrack('slot_booking_viewed', { flow_version: FLOW_VERSION });
    },

    slotSelected: function () {
      var k = 'slot_selected';
      if (_hasFired(k)) return;
      _markFired(k);
      _safeTrack('slot_selected', { flow_version: FLOW_VERSION });
    },

    bookingConfirmed: function () {
      var k = 'booking_confirmed';
      if (_hasFired(k)) return;
      _markFired(k);
      _safeTrack('booking_confirmed', { flow_version: FLOW_VERSION });
    },

    installTest: function () {
      if (!POSTHOG_DEBUG) return;
      _safeTrack('posthog_install_test', { page_key: 'consultative_flow' });
    },
  };

  window.TokAnalytics = TokAnalytics;
})();
